import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-216e2392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Saiba mais"),
  /*#__PURE__*/_createElementVNode("p", null, " A plataforma Ganhe Mais Círculo oferece uma rica variedade de conteúdos voltados para artesanato, empreendedorismo e inovação. Desenvolvidos por especialistas, nossos treinamentos visam enriquecer suas habilidades e conhecimentos em diversas áreas. "),
  /*#__PURE__*/_createElementVNode("div", { class: "default" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}